import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { mediaReviews } from "@/mocks/comments";

export default function AboutPage() {
  const [reviewIdx, setReviewIdx] = useState(0);

  useEffect(() => {
    document.title = "关于我们 - 黑料吃瓜网 | 全网领先的娱乐爆料平台";
  }, []);

  const currentReview = mediaReviews[reviewIdx];

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于黑料吃瓜网",
    description: "黑料吃瓜网品牌介绍、权威认证、媒体口碑与商务联系",
    url: "http://obyqdiy.cn/about",
    mainEntity: {
      "@type": "Organization",
      name: "黑料吃瓜网",
      url: "http://obyqdiy.cn/",
      logo: "http://obyqdiy.cn/logo.png",
      description: "全网领先的娱乐爆料平台，实时追踪网红明星塌房现场与独家吃瓜爆料",
      foundingDate: "2018",
      sameAs: [
        "http://obyqdiy.cn/",
      ],
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "商务合作",
        email: "hello@obyqdiy.cn",
        telephone: "+86-10-8888-6666",
      },
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Brand Intro */}
          <section className="bg-accent-50 py-16 md:py-24 px-4 md:px-8">
            <div className="max-w-7xl mx-auto">
              <span className="inline-block px-4 py-1.5 bg-white text-accent-700 text-xs font-semibold rounded-full mb-6">
                黑料吃瓜网
              </span>
              <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-900 leading-tight mb-6">
                全网领先的
                <br />
                娱乐爆料平台
              </h1>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
                {["实时追踪", "独家爆料", "网红塌房", "每日大赛"].map((item) => (
                  <div
                    key={item}
                    className="text-center p-3 bg-white rounded-lg"
                  >
                    <p className="text-sm font-semibold text-foreground-900">
                      {item}
                    </p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                {[
                  { num: "12,800+", label: "爆料总数" },
                  { num: "2,600+", label: "覆盖明星" },
                  { num: "450万", label: "日活用户" },
                  { num: "2,800", label: "运营天数" },
                ].map((stat) => (
                  <div key={stat.label}>
                    <p className="text-2xl md:text-3xl font-bold text-accent-700">
                      {stat.num}
                    </p>
                    <p className="text-xs text-foreground-500 mt-1">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Certifications */}
          <section className="bg-background-50 py-12 md:py-20 px-4 md:px-8">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                  权威认证
                </h2>
                <p className="text-sm text-foreground-500 max-w-sm md:text-right">
                  历经多年行业深耕，黑料吃瓜网已获得多方权威认可与资质认证
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {/* Main Card */}
                <div className="md:col-span-1 bg-foreground-800 rounded-xl overflow-hidden">
                  <div className="p-5">
                    <h3 className="text-lg font-bold text-white mb-2">
                      媒体合作伙伴
                    </h3>
                    <p className="text-sm text-white/60">
                      与多家主流娱乐媒体、自媒体平台建立深度内容合作，共同构建娱乐爆料生态。
                    </p>
                  </div>
                  <div className="w-full h-48 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20media%20press%20conference%20room%20with%20multiple%20microphones%20and%20cameras%2C%20professional%20journalism%20atmosphere%2C%20dark%20background%20with%20warm%20accent%20lighting%2C%20cinematic%20editorial%20photography&width=600&height=400&seq=about-cert1&orientation=landscape"
                      alt="媒体合作伙伴"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5">
                    <span className="inline-block px-4 py-2 bg-white text-foreground-900 text-xs font-semibold rounded-full">
                      查看合作媒体
                    </span>
                  </div>
                </div>

                {/* Side Cards */}
                <div className="bg-background-100 rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-semibold rounded">
                      平台荣誉
                    </span>
                  </div>
                  <div className="w-full h-36 overflow-hidden rounded-lg mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Golden%20trophy%20and%20award%20certificate%20on%20elegant%20dark%20surface%2C%20achievement%20ceremony%20atmosphere%2C%20warm%20spotlight%20lighting%2C%20cinematic%20editorial%20photography&width=600&height=300&seq=about-cert2&orientation=landscape"
                      alt="平台荣誉"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-2">
                    年度最具影响力娱乐爆料平台
                  </h3>
                  <p className="text-xs text-foreground-500">
                    连续三年荣获行业颁发的"最具影响力娱乐爆料平台"称号，在内容深度与传播速度方面获得业内一致认可。
                  </p>
                </div>

                <div className="bg-background-100 rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] font-semibold rounded">
                      法务资质
                    </span>
                  </div>
                  <div className="w-full h-36 overflow-hidden rounded-lg mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20law%20office%20with%20legal%20books%20and%20scales%20of%20justice%2C%20serious%20formal%20atmosphere%2C%20dark%20wood%20and%20warm%20lighting%2C%20cinematic%20editorial%20photography&width=600&height=300&seq=about-cert3&orientation=landscape"
                      alt="法务资质"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-2">
                    合规运营保障
                  </h3>
                  <p className="text-xs text-foreground-500">
                    持有互联网信息服务许可证，所有爆料内容均经过事实核查与法律风险评估，确保平台合法合规运营。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Media Reviews */}
          <section className="bg-background-100 py-12 md:py-20 px-4 md:px-8">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  （行业口碑）
                </h2>
              </div>

              <div className="relative">
                <div className="flex items-center gap-2 mb-4 justify-center">
                  <span className="px-3 py-1 bg-foreground-800 text-white text-xs font-semibold rounded-full flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500" />
                    {currentReview.rating} 评分
                  </span>
                </div>

                <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed font-heading mb-6 text-center">
                  "{currentReview.content}"
                </blockquote>

                <div className="flex items-center justify-center gap-3">
                  <img
                    src={currentReview.reviewerAvatar}
                    alt={currentReview.reviewer}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {currentReview.reviewer}
                    </p>
                    <p className="text-xs text-foreground-400">
                      {currentReview.mediaName} · {currentReview.role}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-6 justify-center">
                  <button
                    type="button"
                    onClick={() =>
                      setReviewIdx(
                        (i) =>
                          (i - 1 + mediaReviews.length) % mediaReviews.length
                      )
                    }
                    className="w-9 h-9 border border-foreground-200 rounded flex items-center justify-center hover:bg-background-50 transition-colors"
                    aria-label="上一条评价"
                  >
                    <i className="ri-arrow-left-line text-sm" />
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      setReviewIdx((i) => (i + 1) % mediaReviews.length)
                    }
                    className="w-9 h-9 bg-foreground-900 text-white rounded flex items-center justify-center hover:bg-foreground-700 transition-colors"
                    aria-label="下一条评价"
                  >
                    <i className="ri-arrow-right-line text-sm" />
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Contact CTA */}
          <section className="bg-background-50 py-12 md:py-20 px-4 md:px-8">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
                商务合作与爆料投稿
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mb-8">
                24小时接收独家线索，欢迎媒体合作、商务洽谈与爆料投稿
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
                <div className="bg-background-100 rounded-lg p-5">
                  <i className="ri-mail-line text-2xl text-primary-500 mb-2" />
                  <p className="text-xs text-foreground-400">爆料投稿</p>
                  <p className="text-sm font-semibold text-foreground-900">
                    hello@obyqdiy.cn
                  </p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <i className="ri-briefcase-line text-2xl text-primary-500 mb-2" />
                  <p className="text-xs text-foreground-400">商务合作</p>
                  <p className="text-sm font-semibold text-foreground-900">
                    hello@obyqdiy.cn
                  </p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <i className="ri-phone-line text-2xl text-primary-500 mb-2" />
                  <p className="text-xs text-foreground-400">联系电话</p>
                  <p className="text-sm font-semibold text-foreground-900">
                    010-8888-6666
                  </p>
                </div>
              </div>

              <a
                href="mailto:hello@obyqdiy.cn"
                className="inline-flex items-center gap-2 bg-foreground-800 text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-foreground-700 transition-colors whitespace-nowrap"
              >
                联系站长
                <i className="ri-arrow-right-line" />
              </a>
            </div>

            <div className="mt-10 w-full h-32 md:h-48 rounded-xl overflow-hidden max-w-7xl mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20collaboration%20concept%20with%20interconnected%20nodes%20and%20spotlights%2C%20media%20partnership%20atmosphere%2C%20dark%20background%20with%20gold%20and%20red%20accents%2C%20modern%20editorial%20illustration%20style&width=1400&height=400&seq=about-partners&orientation=landscape"
                alt="合作伙伴"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}
